/* tslint:disable */
import * as React from 'react';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';
import MolCalc from './MolCalc'
import Search from './Search'
import About from './About'
import Button from '@material-ui/core/Button'
import {StyleSheet, css} from 'aphrodite';

export const styles = StyleSheet.create({
    noPrint: {
        '@media print': {
            display: "none",
        },
    },
});

const Main = () => (
  <Router>
      <Link to="/" style={{textDecoration: "none"}}>
          <Button variant={"contained"} color={"primary"} style={{marginTop: "20px", marginLeft: "20px"}} className={css(styles.noPrint)}>モル計算機</Button>
      </Link>
      <Link to="/search" style={{textDecoration: "none"}}>
          <Button variant={"contained"} color={"primary"} style={{marginTop: "20px", marginLeft: "20px"}} className={css(styles.noPrint)}>試薬検索支援</Button>
      </Link>
      <Link to="/about" style={{textDecoration: "none"}}>
          <Button variant={"contained"} color={"primary"} style={{marginTop: "20px", marginLeft: "20px"}} className={css(styles.noPrint)}>About</Button>
      </Link>

      <Route exact path="/" component={MolCalc}/>
      <Route path="/search" component={Search}/>
      <Route path="/about" component={About}/>
  </Router>
);

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.tsx